import {
  isMobileScreenViewportSelect,
  isVeryLargeScreenViewportSelect
} from 'modules/viewport/selectors/index.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'

const LIMIT_LARGE_SCREEN = 10
const LIMIT = 8
const LIMIT_SMALL_SCREEN = 6
const LIMIT_MOBILE = 4

export const getPaginationLimitAppSelect = state => {
  const isSmallScreen = isSmallScreenViewportSelect(state)
  const isMobileScreen = isMobileScreenViewportSelect(state)
  const isVeryLargeScreen = isVeryLargeScreenViewportSelect(state)

  if (isMobileScreen) {
    return LIMIT_MOBILE
  }

  if (isSmallScreen) {
    return LIMIT_SMALL_SCREEN
  }

  if (isVeryLargeScreen) {
    return LIMIT_LARGE_SCREEN
  }

  return LIMIT
}
